// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"240":"booking","353":"contact","546":"therapy","957":"privacy"}[chunkId] + "." + {"240":"e2f500fb","353":"daf6c6a7","546":"ba576fbb","957":"e3018f0d"}[chunkId] + ".css";
};